import { createAsyncThunk } from "@reduxjs/toolkit"
import AxiosClient from "../AxiosClient"
import { useAppSelector } from "../storeHooks"


export const getSettingsOfSelectedPlatformAsync = createAsyncThunk(
  'platformSettings/getSettingsOfSelectedPlatformAsync',
  async function (params:{availablePlatformId:string}, toolkit) {
    return await AxiosClient('GET', `/available-platform/${params.availablePlatformId}/settings`, [], toolkit, [] )
  }
)
export const getSettingsOfPrimaryPlatformAsync = createAsyncThunk(
  'platformSettings/getSettingsOfPrimaryPlatformAsync',
  async function (params:{primaryAvailablePlatformId:number}, toolkit) {
    return await AxiosClient('GET', `/available-platform/${params.primaryAvailablePlatformId}/settings?type=MAIN_STORE_SETTING`, [], toolkit, [] )
  }
)

 // new api for get settings of selected platform
export const getSettingsOfSelectedPlatformAsyncNew = createAsyncThunk(
    'platformSettings/getSettingsOfSelectedPlatformAsync',
    async function (params:{availablePlatformId:string, primaryPlatformId:number, platform_id: string, erp_flow: boolean, type: string, fetch_limited_data?: boolean, current_setting_platform_id?: string | number}, toolkit) {
      // const erp_flow = params.erp_flow ? '&erp_flow=1' : ''
      const erp_flow = '&erp_flow=1'
      const settingType = (params.type === 'SECONDARY_STORE_SETTING') ? `&related_available_platform=${params.primaryPlatformId}` : ''
      const fetchLimitedData = `&fetch_limited_data=${params.fetch_limited_data ?? true}`
      const currentSettingPlatformId =
        params.current_setting_platform_id != null
          ? `&current_setting_platform_id=${params.current_setting_platform_id}`
          : ''
      return await AxiosClient('GET', `/available-platform/${params.availablePlatformId}/settings?platform_id=${params.platform_id}&type=${params.type}${settingType}${erp_flow}${fetchLimitedData}${currentSettingPlatformId}`, [], toolkit, [] )
    }
  )
  
  // new api for get settings of primary platform
  export const getSettingsOfPrimaryPlatformAsyncNew = createAsyncThunk(
    'platformSettings/getSettingsOfPrimaryPlatformAsync',
    async function (params:{primaryAvailablePlatformId:number, selectedPlatformId:string, primaryPlatformId: number, erp_flow: boolean, type: string, fetch_limited_data?: boolean, current_setting_platform_id?: string | number}, toolkit) {
      //  const erp_flow = params.erp_flow ? '&erp_flow=1' : ''
      const erp_flow = '&erp_flow=1'
      const fetchLimitedData = `&fetch_limited_data=${params.fetch_limited_data ?? true}`
      const currentSettingPlatformId =
        params.current_setting_platform_id != null
          ? `&current_setting_platform_id=${params.current_setting_platform_id}`
          : ''
      return await AxiosClient('GET', `/available-platform/${params.primaryAvailablePlatformId}/settings?type=${params.type}&related_available_platform=${params.selectedPlatformId}&platform_id=${params.primaryPlatformId}${erp_flow}${fetchLimitedData}${currentSettingPlatformId}`, [], toolkit, [] )
    }
  )

  const resolveSearchPlatformFieldEndpoint = (nextUrl: string): string => {
    const apiBase = process.env.REACT_APP_API_URL || ''

    if (nextUrl.startsWith(apiBase)) {
      return nextUrl.slice(apiBase.length)
    }

    try {
      const parsed = new URL(nextUrl)
      const path = parsed.pathname.replace(/^\/market_connect/, '')
      return `${path}${parsed.search}`
    } catch {
      return nextUrl
    }
  }

  export const searchPlatformFieldDataAsync = createAsyncThunk(
    'platformSettings/searchPlatformFieldDataAsync',
    async function (
      params: {
        platform_field_id?: number | string
        search_string?: string
        next_url?: string
        signal?: AbortSignal
      },
      toolkit
    ) {
      if (params.next_url) {
        return await AxiosClient(
          'GET',
          resolveSearchPlatformFieldEndpoint(params.next_url),
          [],
          toolkit,
          {},
          params.signal
        )
      }

      return await AxiosClient(
        'GET',
        `/api/search-platform-field-data/${params.platform_field_id}`,
        [],
        toolkit,
        {search_string: params.search_string ?? ''},
        params.signal
      )
    }
  )


  //api use in dynamic setting for get saved field mapping by their id
  export const getSavedFieldMappingsDataAsyncByMappingId = createAsyncThunk(
    'platformSettings/getSavedFieldMappingsDataAsyncByMappingId',
    async function (params:{mappingId:number}, toolkit) {
      return await AxiosClient('GET', `/api/field-mapping-with-setting/${params.mappingId}`, [], toolkit, [] )
    }
  )
 
  //new api use in dynamic setting for getting all saved field mappings by their ids
  export const getSavedFieldMappingsDataAsync = createAsyncThunk(
    'platformSettings/getSavedFieldMappingsDataAsyncByMappingId',
    async function (params:{field_mapping_ids:[]}, toolkit) {
      return await AxiosClient('GET', `/api/field-mapping-with-setting?field_mappings_list=[${params.field_mapping_ids}]`, [], toolkit, [] )
    }
  )

  /**
   * @description saveFieldMappingForSectionWiseAsync is used for "save" and "update" both
   */
  export const saveFieldMappingForSectionWiseAsync = createAsyncThunk(
    'platformSettings/saveFieldMappingForSectionWiseAsync',
    async function (params:{mappingId:number|null, payload:any}, toolkit) {
      if(params.mappingId){
        return await AxiosClient('POST', `/api/field-mapping-with-setting/${params.mappingId}`, params.payload, toolkit, [] )
      }else{
        return await AxiosClient('POST', `/api/field-mapping-with-setting`, params.payload, toolkit, [] )
      }
    }
  )

  export const saveFieldMappingsAsync = createAsyncThunk(
    'platformSettings/saveFieldMappingsAsync',
    async function (params:{field_mapping_ids:[], payload:any}, toolkit) {
        return await AxiosClient('POST', `/api/field-mapping-with-setting?field_mappings_list=[${params.field_mapping_ids}]`, params.payload, toolkit, [] )
    }
  )

  export const getAvailablePlatformAsync = createAsyncThunk(
    'platformSettings/getAvailablePlatformAsync',
    async function (params:{selectedAvailablePlatformId:string}, toolkit) {
      return await AxiosClient('GET', `/available-platform/${params.selectedAvailablePlatformId}`, [], toolkit, [] )
    }
  )

  export const refreshMappingAsync = createAsyncThunk(
    'platformSettings/refreshMappingAsync',
    async function (params:{payload:any}, toolkit) {
        return await AxiosClient('POST', `/api/refresh-mapping`, params.payload, toolkit, [] )
    }
  )

  export const getPlatformSettingShortcodesAsync = createAsyncThunk(
    'platformSettings/getPlatformSettingShortcodesAsync',
    async function (
      params: {platform_id?: number | string; setting_name?: string},
      toolkit
    ) {
      return await AxiosClient(
        'GET',
        '/platform-setting-shortcodes',
        [],
        toolkit,
        {
          platform_id: params.platform_id,
          setting_name: params.setting_name,
        }
      )
    }
  )